import BarChartIcon from '@mui/icons-material/BarChart';
import { useHourlyHeatmap } from './useHourlyHeatmap';
import { HeatmapBar } from './HeatmapBar';
import React from 'react';

interface HourlyHeatmapProps {
  data: {
    hour: number;
    count: number;
  }[];
}

export const HourlyHeatmap: React.FC<HourlyHeatmapProps> = ({ data }) => {
  const { hours, maxCount, getColorClass } = useHourlyHeatmap(data);

  return (
    <div className='bg-white p-10 rounded-2xl shadow-md border border-slate-100 h-full hover:shadow-xl transition-shadow duration-300'>
      <div className='flex justify-between items-center mb-10'>
        <div className='flex flex-col'>
          <h3 className='text-slate-500 text-base font-bold uppercase tracking-widest flex items-center gap-3'>
            <BarChartIcon className='!w-6 !h-6 text-orange-500' />
            Demanda por Hora
          </h3>
        </div>
        <div className='flex items-center gap-4 px-4 py-2 bg-slate-50 rounded-xl border border-slate-100'>
          <span className='text-xs font-bold text-slate-400 uppercase tracking-tighter'>
            Intensidad:
          </span>
          <div className='flex gap-1.5'>
            <div className='w-3 h-3 rounded-sm bg-orange-100' />
            <div className='w-3 h-3 rounded-sm bg-orange-500' />
            <div className='w-3 h-3 rounded-sm bg-orange-900' />
          </div>
        </div>
      </div>

      <div className='flex flex-col gap-6'>
        {/* The Heatmap Grid */}
        <div className='grid grid-cols-11 gap-2 h-48 items-end'>
          {hours.map((item) => (
            <HeatmapBar
              key={item.hour}
              hour={item.hour}
              count={item.count}
              maxCount={maxCount}
              colorClass={getColorClass(item.count)}
            />
          ))}
        </div>

        {/* Axis Labels */}
        <div className='grid grid-cols-11 text-xs font-black text-slate-500 text-center mt-2 px-1'>
          {hours.map((item) => (
            <span key={item.hour} className='transition-colors'>
              {item.hour}h
            </span>
          ))}
        </div>
      </div>
    </div>
  );
};
